<template>
  <div class="child-card">
    <div class="child-card__header">

      <div class="children__block-card-tight-details">
        <BAvatar
          size="48"
          :src="child.avatar"
          :text="avatarText(child.full_name)"
          class="children__block-avatar"
        />
        <h3 class="child-card__name">{{ child.full_name }}</h3>
      </div>

      <button class="child-card__edit">
        <PencilSVG
          class="icon-edit"
          @click="editChild"
        />
      </button>
    </div>

    <div class="child-card__section">
      <div
        class="child-card__section-title"
        @click="isCurrentApplicationShow = !isCurrentApplicationShow"
      >
        <span>Current Applications
          <span class="child-card__section-title__counter">{{ child.currentApplications.length }}</span>
        </span>
        <span
          v-if="child.currentApplications.length"
          class="collapse-icon"
          :class="{'open': isCurrentApplicationShow}"
        ></span>
      </div>
      <b-collapse
        :id="'collapse-child-current-applications' + child.id"
        v-model="isCurrentApplicationShow"
      >
        <div class="child-card__applications">
          <ApplicationCard
            v-for="(app, index) in child.currentApplications"
            :key="child.id + 'current-application-' + index"
            :application="app"
          />
        </div>
      </b-collapse>
    </div>

    <div class="child-card__section">
      <div
        class="child-card__section-title"
        @click="isPastApplicationShow = !isPastApplicationShow"
      >
        <span>Past Applications
          <span class="child-card__section-title__counter">{{ child.pastApplications.length }}</span>
        </span>
        <span
          v-if="child.pastApplications.length"
          class="collapse-icon"
          :class="{'open': isPastApplicationShow}"
        ></span>
      </div>
      <b-collapse
        :id="'collapse-child-past-applications' + child.id"
        v-model="isPastApplicationShow"
      >
        <div class="child-card__applications">
          <ApplicationCard
            v-for="(app, index) in child.pastApplications"
            :key="child.id + 'past-application-' + index"
            :application="app"
          />
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import ApplicationCard from '@/views/My/ChildApplications/ApplicationCard.vue'
import { BAvatar, BCollapse } from 'bootstrap-vue'
import PencilSVG from '@/assets/images/icons/pencil.svg'

export default {
  components: {
    BAvatar,
    BCollapse,
    PencilSVG,
    ApplicationCard
  },
  props: {
    child: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isCurrentApplicationShow: true,
      isPastApplicationShow: false,
    }
  },
  methods: {
    avatarText(value){
      if (!value) return ''
      const nameArray = value.split(' ')
      return nameArray.map(word => word.charAt(0).toUpperCase()).join('')
    },
    editChild(){
      this.$emit('editChild', this.child)
    },
  },
}
</script>

<style scoped lang="scss">

</style>